// extracted by mini-css-extract-plugin
export default {"skeleton":"ProjectSkeleton_skeleton__YoJEP","image":"ProjectSkeleton_image__escvJ","top":"ProjectSkeleton_top__28+-I","description":"ProjectSkeleton_description__-Bas-"};